<template>
  <div class="flex justify-center">
    <plant-issues
      v-for="issueGroup in issueGroups"
      :key="issueGroup.key"
      :type="issueGroup.type"
      :severity="issueGroup.severity"
      :show-tooltip="true"
      :snoozed-until="issueGroup.snoozed"
      :total-count="issueGroup.totalCount"
      class="ml-1"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PlantJson } from '@/data/plants/PlantJson.ts';
import PlantIssues from '@/presentation/components/status/icon/PlantIssues.vue';
import _ from 'lodash';

export default {
  name: 'ExistingIssuesCell',
  components: { PlantIssues },
  props: {
    plantJson: {
      type: Object as PropType<PlantJson>,
      required: true,
    },
  },
  computed: {
    issueGroups() {
      if (this.plantJson.meter_issues.length === 0) return;

      const issuesWithoutLatest = this.plantJson.meter_issues.filter(
        (issue) => issue.id !== this.plantJson.issue.id,
      );

      let groupedByType = _.groupBy(issuesWithoutLatest, 'type_name');

      return Object.keys(groupedByType).map((type) => {
        const issues = groupedByType[type];
        const count = issues.length;
        const earliestSnoozedUntil = _.sortBy(issues, 'snoozed_until').find(
          (issue) => issue.snoozed_until !== null,
        );

        return {
          key: issues[0].id + type,
          type: type,
          severity: 'NOK',
          snoozed: earliestSnoozedUntil
            ? earliestSnoozedUntil.snoozed_until
            : null,
          totalCount: count > 1 ? count : null,
        };
      });
    },
  },
};
</script>

<style scoped></style>
